import { guuid } from '@aretheyhappy/utils';
import MultiStepFilterItem from './MultiStepFilterItem';
/**
 * Definition for an individual item that will appear on a MutliStepFilterConfigList
 */
class MultiStepFilterConfigListItem {
    constructor(value = '') {
        this.uid = guuid();
        // Value for this item when selected
        this.value = '';
        // Any config object, defined by consumer
        this.config = {};
        // If this item has the option for configuration
        this.hasConfig = false;
        // If this item is currently locked
        this.isLocked = false;
        // Label presenting the selected config
        this.config_label = false;
        // MultiStepFilterItem that selected this one, that way we can fill out breadcrumbs
        this.msf_item = new MultiStepFilterItem();
        this.value = value;
    }
    setValue(value) { this.value = value; return this; }
    setConfig(value) {
        this.setHasConfig(true);
        this.config = value;
        return this;
    }
    setHasConfig(value) { this.hasConfig = value; return this; }
    setLocked(value) { this.isLocked = value; return this; }
    setMSTItem(value) { this.msf_item = value; return this; }
    setConfigLabel(value) { this.config_label = value; return this; }
}
;
export { MultiStepFilterConfigListItem };
export default MultiStepFilterConfigListItem;
//# sourceMappingURL=MultiStepFilterConfigListItem.js.map